import { CommunicationProvider, useCommunication } from "@/lib/CommunicationWrapper"
import { CalendarSyncGate } from "../signup/CalendarSyncGate"
import { GoogleOAuthProvider } from "@react-oauth/google"
import { X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useCalendarSync } from "@/lib/calendarSync";



export const CalendarSettingsContent = () => {

    const { getOptions, ready, useRerenderListener, sendMessage } = useCommunication();
    const { handleInitialSync, ensureBetterCampusCalendar, handleResetCalendar } = useCalendarSync();
    const reinitStarted = useRef(false);

    const [resetComplete, setResetComplete] = useState(false);

    const { options, trigger } = useRerenderListener(["google_cal_push_settings", "microsoft_cal_push_settings"]);

    const params = new URLSearchParams(window.location.search);
    const shouldReinit = params.get("reinit") === "true";

    useEffect(() => {
        if (!resetComplete) return;

        const hasCalendar = options?.google_cal_push_settings?.betterCampusCalendarId || options?.microsoft_cal_push_settings?.betterCampusCalendarId;

        if (hasCalendar) {
            handleInitialSync();
        }
    }, [resetComplete, options]);

    const closeModal = () => {
        sendMessage({
            type: "CLOSE_SHARED_COMPONENT",
            payload: {
                component: "CalendarSyncGate"
            }
        })
    }

    /*
    useEffect(() => {

        if (!ready) return;
        if (!shouldReinit) return;
        if (reinitStarted.current) return;

        /*
        reinitStarted.current = true;

        const performReinit = async () => {
            try {
                const options = getOptions("sync");
                const hasCalendar = options?.google_cal_sync_token || options?.microsoft_cal_sync_token;
                const pushEnabled = options?.google_cal_push_settings?.pushEnabled || options?.microsoft_cal_push_settings?.pushEnabled;

                // not opted in for calendar or push disabled
                if (!hasCalendar || !pushEnabled) {
                    return;
                }

                // Delete existing calendar, clear events, create new one, sync
                await handleResetCalendar();
                setResetComplete(true);

                console.log(["calendar] calendar reset complete"])
                await ensureBetterCampusCalendar();
                console.log(["calendar] better campus calendar ensured"])
                await handleInitialSync();
                console.log(["calendar] initial sync complete"])

                //window.parent.postMessage({ type: 'CALENDAR_REINIT_COMPLETE' }, '*');
            } catch (error) {
                /*
                window.parent.postMessage({
                    type: 'CALENDAR_REINIT_ERROR',
                    error: error instanceof Error ? error.message : 'Unknown error'
                }, '*');
                
            }
        };

        performReinit();
        

    }, [ready]);
    */

    return (
        <div className="p-8 relative bg-white h-full">
            <button className="absolute top-4 right-4 p-1 rounded-md hover:bg-gray-100 transition-colors cursor-pointer" aria-label="Close" onClick={closeModal}>
                <X className="w-5 h-5 text-gray-500" />
            </button>
            <h1 className="text-xl font-semibold text-black mb-[5px]">Calendar Sync</h1>
            <CalendarSyncGate />
        </div>
    )
}

export const CalendarSettings = () => {

    return (
        <CommunicationProvider requiresLocalStorage={true}>
            <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ""}>
                <CalendarSettingsContent />
            </GoogleOAuthProvider>
        </CommunicationProvider>
    )
}